module.exports = {"id":"182493","name":"Diego Godín","rating":"88","photo":"./data/images/photos/3/182493.png","club":{"name":"Atlético Madrid","logo":"./data/images/clubs/AtleticoMadrid.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoGodin0.json
// module id = 1084
// module chunks = 0